import { render } from "./ContactformForClients.vue?vue&type=template&id=7644e627&scoped=true"
import script from "./ContactformForClients.vue?vue&type=script&lang=js"
export * from "./ContactformForClients.vue?vue&type=script&lang=js"

import "./ContactformForClients.vue?vue&type=style&index=0&id=7644e627&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7644e627"

export default script